// extracted by mini-css-extract-plugin
export default {"emptyDiv":"emptyDiv__48uRs"};